import { render, staticRenderFns } from "./PointChart_new.vue?vue&type=template&id=be675dd0&"
import script from "./PointChart_new.vue?vue&type=script&lang=js&"
export * from "./PointChart_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports